import { PrinterIcon, ScaleIcon } from '@heroicons/react/24/outline';

const overview = `Swiggy, the leading online food delivery platform, is a game-changer for restaurant owners on Pallet. With Swiggy's extensive reach, cutting-edge technology, and customer-centric approach, Pallet's restaurant owners can tap into a multitude of benefits and unlock new avenues for growth and success.`;
const features = [
  [
    'Preferred by over 330 million consumers in India, making it the largest scale payment gateway.',
  ],
  [
    "Trusted by India's leading online brands including Uber, Flipkart, Zomato, Airtel, IRCTC, LIC, and more, establishing itself as India's most reliable PG",
  ],
  [
    'Offers industry-best prices with a guarantee of being twice as affordable as other payment gateways, along with 0% transaction fees on UPI and Rupay payments',
  ],
  ['Boosts conversions through affordability options such as EMI and Paytm Postpaid.'],
  [
    'Employs superior technology with industry-best success rates and a 99.99% up-time, enabling it to handle three times more transactions per second than other payment gateways.',
  ],
  ['Provides superfast next-day settlements, even on holidays and weekends.'],
  [
    'Features a powerful dashboard that offers payment analytics at your fingertips, allowing you to gain insights by payment source and customer cohorts.',
  ],
  [
    'Facilitates instant refunds with a seamless process, allowing you to initiate refunds with just a click from your Paytm for Business dashboard.',
  ],
];

const thermalOverview =
  'Thermal printers are dot-matrix printers that operate by driving heated pins against special heat-sensitive paper to print the image onto the paper. They are quiet, but many people don\'t like the feel of thermal paper, and the images tend to fade.';

const thermalFeatures = [
  ['A thermal printer is a device that prints on special thermal paper.'],
  [
    'Eliminate the need for laser printers, A4 paper, expensive toner cartridges and document enclosed wallets as well as the storage, distribution and purchasing of these items.',
  ],
  [
    'A lightweight design makes them easy to take with you anywhere. Use them in the office or warehouse, at tradeshows and on demos.',
  ],
  ['They are also ideal for printing receipts, tickets, delivery notes and labels on the move.'],
];

const AppList = [
  {
    name: 'Thermal Printer',
    icon: <PrinterIcon />,
    urlName: 'thermal-printer',
    category: ['Thermal Printer'],
    type: 'printer',
    shortdescription: 'Manage configuration of your thermal printer',
    description: 'Manage configuration of your thermal printer',
    img: 'https://i.imgur.com/26p2ntd.jpg',
    overview: thermalOverview,
    features: thermalFeatures,
    selected: false,
    device: ['Posiflex', 'TVS'],
    model: 'Thermal Printer',
    models: {
      Posiflex: 'Posiflex PP-8802',
      TVS: 'TVS RP 3160 GOLD',
    },
  },
  {
    name: 'Mobile Thermal Printer (Shreyans)',
    icon: <PrinterIcon />,
    urlName: 'thermal-shreyans',
    category: ['Thermal Printer'],
    type: 'printer',
    shortdescription: 'Manage configuration of your mobile printer',
    description: 'Manage configuration of your  mobile printer',
    img: 'https://shreyanspos.com/wp-content/uploads/2023/09/new-logo_s-2048x387-1-1536x290.png',
    overview: thermalOverview,
    features: thermalFeatures,
    selected: false,
    device: 'Shreyans',
    model: 'SC588',
  },
  {
    name: 'TVS Label Printer (LP 46 LITE)',
    urlName: 'tvs-label-printer',
    category: ['Label Printer'],
    type: 'printer',
    shortdescription: 'Manage configuration of your TVS LP 46 LITE label printer',
    description: 'Manage configuration of your TVS LP 46 LITE label printer',
    img: 'https://www.tvs-e.in/wp-content/uploads/2021/06/Logo-icon-02.png',
    overview:
      'The TVS LP 46 LITE is a direct thermal label printer designed for high-speed label printing. It uses TSPL command language and connects via USB, making it ideal for printing kitchen order labels, food stickers, and item tags in restaurant and retail environments.',
    features: [
      ['Direct thermal printing — no ink or toner required.'],
      ['Supports TSPL label programming language for precise label layout.'],
      ['USB connectivity for fast and reliable data transfer.'],
      ['Ideal for printing kitchen order labels, food stickers, and item tags.'],
    ],
    selected: false,
    device: 'TVS-LP46',
    model: 'TVS LP 46 LITE',
  },
  {
    name: 'Weighing Scale',
    icon: <ScaleIcon />,
    urlName: 'weighing-scale',
    category: ['Weighing Scale'],
    type: 'scale',
    shortdescription: 'Manage configuration of your weighing scale',
    description: 'Manage configuration of your weighing scale',
    img: 'https://m.media-amazon.com/images/I/71KYMP8g5vS.jpg',
    overview:
      'Easily manage and configure your weighing scale to ensure accurate measurements, seamless POS integration, and efficient itemized billing. Ideal for retail environments, this device helps streamline operations and improve customer experience.',
    features: [
      ['Accurately weighs products and integrates directly with your POS system for real-time pricing.'],
      ['Supports automatic weight detection to speed up checkout and reduce human error.'],
      ['User-friendly configuration panel for quick calibration and customization.'],
      ['Compact and durable design makes it ideal for both counter and warehouse use.'],
    ],
    selected: false,
    device: 'Prrestige',
    model: 'TT 230',
  },
  {
    name: 'Cash Drawer',
    urlName: 'cash-drawer',
    category: ['Cash Drawer'],
    type: 'cashdrawer',
    shortdescription: 'Manage your cash drawer',
    description: 'Manage your cash drawer',
    selected: false,
    device: 'APG',
    model: 'APG Series 100',
  },
  {
    name: 'EDC Terminal',
    urlName: 'edc-terminal',
    category: ['EDC Terminal'],
    type: 'payment',
    shortdescription: 'Manage your EDC terminal',
    description: 'Manage your EDC terminal',
    selected: false,
    device: 'Verifone',
    model: 'Verifone P400',
  },
];

export default AppList;
